<template>
  <div v-if="showServiceCall">
    <p-vue-panel
      :class="serviceCall.PriorityCssClass"
      :name="'serviceCall' + serviceCall.PID"
    >
      <template #header>
        <div class="p-d-flex p-jc-between" style="width:100%">
          <div class="p-panel-title">
            <div @click.self="showServiceCallData(ServiceCallActions.View)">
              {{
                !serviceCall.showTranslatedSubject
                  ? serviceCall.Subject
                  : serviceCall.translatedSubject
              }}
            </div>
            <div
              v-if="showTranslateBtn"
              @click="translate"
              class="service-call-data p-mt-1 translate"
            >
              <u>{{
                !serviceCall.showTranslatedSubject
                  ? __(translateBtnTitle)
                  : __("View source")
              }}</u>
            </div>

            <div class="p-mt-1">{{ serviceCall.BuildingName }}</div>
            <div v-if="serviceCall.Compound" class="p-mt-1">
              {{ __("compound") }} {{ serviceCall.Compound }}
            </div>
          </div>
          <div>
            <span
              class="serviceCall-status"
              :class="{
                inTreatment: serviceCall.LastUpdateDesc,
                awaitingTreatment: !serviceCall.LastUpdateDesc,
                closing: serviceCall.ClosingDate,
              }"
              @click="showChangeStatusDialog(serviceCall)"
            >
              {{ __(serviceCall.statusDesc) }}
            </span>
          </div>
        </div>
      </template>
      <div class="p-d-flex p-jc-between">
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Reading") }}:</span>
          <span class="service-call-data">{{ serviceCall.PID }}</span>
        </div>
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Reading Date") }}:</span>
          <span class="service-call-data">{{
            dateFormat(serviceCall.OpenDate, true, false, true)
          }}</span>
        </div>
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Last update") }}:</span>
          <span class="service-call-data">{{
            dateFormat(serviceCall.LastDateUpdate, false, false, true)
          }}</span>
        </div>
        <div class="p-d-flex p-flex-column" v-if="serviceCall.ClosingDate">
          <span>{{ __("Is Treated") }}:</span>
          <span class="service-call-data">{{
            dateFormat(serviceCall.ClosingDate, false, false, true)
          }}</span>
        </div>
        <div class="p-d-flex p-flex-column" v-else>
          <span>{{ __("Due") }}:</span>
          <span
            :class="{
              'service-call-data': true,
              dueDate: pastDueDate,
            }"
            >{{ dateFormat(serviceCall.DueDate, false, false, true) }}</span
          >
        </div>
      </div>
      <div class="links p-d-flex p-jc-between p-my-2">
        <!-- {{ serviceCall.action }} -->
        <div
          :class="{ active: serviceCall.action == ServiceCallActions.Image }"
          class="image p-overlay-badge"
          @click="showServiceCallData(ServiceCallActions.Image)"
        >
          <p-vue-badge
            :value="serviceCall.imgCnt"
            severity="success"
            v-if="serviceCall.imgCnt > 0"
          ></p-vue-badge>
          <i-icon name="cam" />
        </div>
        <div
          :class="{ active: serviceCall.action == ServiceCallActions.Money }"
          class="money p-overlay-badge"
          @click="showServiceCallData(ServiceCallActions.Money)"
        >
          <p-vue-badge
            :value="serviceCall.moneyCnt"
            severity="success"
            v-if="serviceCall.moneyCnt > 0"
          ></p-vue-badge>
          <i-icon name="money" />
        </div>
        <div
          :class="{
            active: serviceCall.action == ServiceCallActions.ProblemSub,
          }"
          class="update p-overlay-badge"
          @click="showServiceCallData(ServiceCallActions.ProblemSub)"
        >
          <p-vue-badge
            :value="serviceCall.problemsSubCnt"
            severity="success"
            v-if="serviceCall.problemsSubCnt > 0"
          ></p-vue-badge>
          <i-icon name="memo" />
        </div>
        <div
          :class="{ active: serviceCall.action == ServiceCallActions.Edit }"
          class="edit"
          @click="showServiceCallData(ServiceCallActions.Edit)"
        >
          <i-icon name="pen" />
        </div>
        <div
          :class="{
            rotate: serviceCall.action == ServiceCallActions.View,
            active: serviceCall.action == ServiceCallActions.View,
          }"
          class="arrow-svg view"
          @click="showServiceCallData(ServiceCallActions.View)"
        >
          <i-icon name="arrow" />
        </div>
      </div>
      <p-transition-expand>
        <div v-show="isShowActions || isOneServiceCall">
          <local-actions
            :serviceCall="serviceCall"
            @DeleteServiceCall="$emit('DeleteServiceCall', $event)"
            @changeAction="showServiceCallData"
          ></local-actions>
        </div>
      </p-transition-expand>
    </p-vue-panel>
  </div>
  <i-override-dialog
    v-model:visible="showDialog"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :close="
      () => {
        showAddUpdate = false;
        showDialog = false;
      }
    "
    :modal="true"
    :dismissableMask="true"
    :title="
      showAddUpdate
        ? __('Add update')
        : serviceCallSelected.mtcCheckListID
        ? __('check list')
        : __('Change reading {0} status to', [serviceCallSelected.PID]) + ':'
    "
  >
    <local-add-problem-sub
      v-if="showAddUpdate"
      :PID="serviceCall.PID"
      @addProblemSub="addProblemSub"
      :close="
        () => {
          showAddUpdate = false;
          showDialog = false;
        }
      "
    ></local-add-problem-sub>
    <div v-else class="p-d-flex p-jc-around">
      <p-vue-button
        v-if="
          (!serviceCallSelected.ClosingDate &&
            !serviceCallSelected.LastUpdateDesc) ||
            serviceCallSelected.ClosingDate
        "
        style="width:45%"
        class="button p-button-lg p-button-rounded p-button-success"
        :label="__('In treatment')"
        @click="changeStatus($event, 0)"
      />

      <p-vue-button
        v-if="!serviceCallSelected.ClosingDate"
        class="button p-button-lg p-button-rounded p-button-success"
        :label="__('Is Treated')"
        style="width:45%"
        @click="changeStatus($event, 1)"
      />
    </div>
  </i-override-dialog>
  <p-vue-confirm-popup></p-vue-confirm-popup>
</template>

<script>
import { dateFormat, isRTL, isRussian, isEnglish } from "@/services/apointUtil";
import { ServiceCallActions } from "@/configs/enums";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import LocalActions from "./actions";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import { ScrollTo } from "@/services/Scroll";
import PTransitionExpand from "@/components/partials/p-transition-expand";
import LocalAddProblemSub from "./add-problem-sub";

export default {
  props: {
    serviceCall: {
      type: Object,
    },
    showServiceCall: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    "showServiceCallData",
    "refreshServiceCall",
    "DeleteServiceCall",
    "getTranslatedSubject",
    "showCheckList",
  ],
  components: {
    LocalActions,
    PTransitionExpand,
    LocalAddProblemSub,
  },
  data() {
    return {
      dateFormat,
      ServiceCallActions,
      showDialog: false,
      serviceCallSelected: {},
      isShowActions: false,
      showAddUpdate: false,
    };
  },
  mounted() {
    this.serviceCallSelected = this.serviceCall;
    this.showAddUpdate = this.serviceCallSelected.showAddUpdate;
    if (this.showAddUpdate) {
      this.showDialog = true;
    }
    if (!this.showServiceCall)
      this.showChangeStatusDialog(this.serviceCallSelected);
  },
  methods: {
    localIsRTL(s) {
      return isRTL(s);
    },
    showServiceCallData(action) {
      setTimeout(() => {
        this.isShowActions = false;
        this.isShowActions = action != ServiceCallActions.None;
      }, 100);
      this.$emit("showServiceCallData", this.serviceCall, action);
      ScrollTo(
        document.getElementsByName("serviceCall" + this.serviceCall.PID)[0]
      );
    },
    showChangeStatusDialog() {
      if (this.serviceCall.mtcCheckListID)
        this.$emit("showCheckList", this.serviceCall.PID);
      else {
        this.serviceCallSelected = this.serviceCall;
        this.showDialog = true;
      }
    },
    changeStatus(event, status) {
      this.showDialog = true;
      if (status == 1) {
        if (this.serviceCallSelected.DateDiffOpenDateAndGetDate != 0)
          this.$confirm.require({
            target: event.currentTarget,
            message: __(
              "This referral was opened {0} days ago, do you want to send a referral closing message?",
              [this.serviceCallSelected.DateDiffOpenDateAndGetDate]
            ),
            icon: "pi pi-exclamation-triangle",
            accept: () => {
              this.changeStatusInDB("1", status);
            },
            reject: () => {
              this.changeStatusInDB(1, status);
            },
          });
        else this.changeStatusInDB(1, status);
      } else this.changeStatusInDB(1, status);
    },
    changeStatusInDB(sendSms, status) {
      // this.showDialog = false;
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("PID", this.serviceCallSelected.PID, apiPType.Int),
        apiParam("IsTreated", status == "1", apiPType.Bit),
        apiParam("IsSmsSend", sendSms == "1", apiPType.Bit),
      ];
      callProc("WorkerApp_UpdateServiceCallStatus", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          if (result.procReturnValue == 0) {
            if (result.Table && result.Table[0]) {
              showSuccessOrFailedModal(
                __("Reading status is successfully modified")
              );

              this.serviceCallSelected = result.Table[0];
              if (status == "1") {
                this.serviceCallSelected.showAddUpdate = true;
                // this.serviceCallSelected.action = ServiceCallActions.None;
                this.showAddUpdate = true;
              } else this.showDialog = false;

              setTimeout(() => {
                this.$emit("refreshServiceCall", this.serviceCallSelected);
              }, 1000);
            }
          } else {
            showSuccessOrFailedModal(__("Failed to update"), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateServiceCallStatus");
        });
    },
    addProblemSub() {
      // console.log(problemSub);
      this.showDialog = false;
      this.showAddUpdate = false;
    },
    translate() {
      let isOnlyShowTranslate =
        this.serviceCall.translatedSubject &&
        this.trunslateSubject_Lang == this.language.code;
      this.$emit(
        "getTranslatedSubject",
        this.serviceCall.PID,
        this.language.code,
        isOnlyShowTranslate
      );
    },
    changeLangCheckTranslate() {
      if (
        this.subject_Lang != this.language.code &&
        this.trunslateSubject_Lang != this.language.code
      )
        this.translate();
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
      language: (state) => state.local,
    }),
    isOneServiceCall() {
      return this.$route.name == "OneServiceCall";
    },
    pastDueDate() {
      return new Date(this.serviceCall.DueDate) < new Date();
    },
    translateBtnTitle() {
      switch (this.language.code) {
        case "he":
          return "Translate into Hebrew";
        case "en":
          return "Translate into English";
        case "ru":
          return "Translate into Russian";
      }
      return "";
    },
    subject_Lang() {
      if (this.serviceCall.Subject == " ") return "";
      if (this.localIsRTL(this.serviceCall.Subject)) return "he";
      if (isEnglish(this.serviceCall.Subject)) return "en";
      if (isRussian(this.serviceCall.Subject)) return "ru";
      return "";
    },
    trunslateSubject_Lang() {
      if (this.serviceCall.translatedSubject == " ") return "";
      if (this.localIsRTL(this.serviceCall.translatedSubject)) return "he";
      if (isEnglish(this.serviceCall.translatedSubject)) return "en";
      if (isRussian(this.serviceCall.translatedSubject)) return "ru";
      return "";
    },
    showTranslateBtn() {
      return this.subject_Lang != this.language.code;
    },
  },
  watch: {
    showDialog() {
      if (!this.showDialog) this.showAddUpdate = false;
    },
    // language() {
    //   this.changeLangCheckTranslate();
    // },
  },
};
</script>

<style scoped>
.links .active {
  border: 1px solid var(--color-success);
  border-radius: 50%;
}

.links .image {
  padding: 7px 4px 0px 7px;
}

.links .money,
.links .update {
  padding: 8px 2px 0px 9px;
}

.links .edit {
  padding: 7px 0px 0px 11px;
}

.links .view {
  padding: 6px 9px;
}

:deep(.svg) {
  color: var(--color-success);
  width: 25px;
  height: 25px;
}

.arrow-svg:deep(.svg) {
  width: 18px;
  height: 18px;
}

.rotate {
  transform: rotate(180deg);
}

.service-call-data {
  color: var(--color-accent);
}

.service-call-data.dueDate {
  color: red;
}

.inTreatment {
  color: #d39603;
}

.awaitingTreatment {
  color: #b90000;
}

.closing {
  color: var(--color-success);
}

.Rborder {
  border-right: 5px solid red;
}

.translate {
  font-weight: 500;
  font-size: 14px;
}

:deep(.p-badge) {
  color: #ffffff;
  font-size: 0.6rem !important;
  font-weight: 700;
  min-width: 1rem;
  height: 1rem;
  line-height: 1rem;
  top: 3px;
  right: 3px;
}
</style>
